import type { UUID } from "node:crypto";
import { SURVEY_MODE, SURVEY_QUERY_PARAMS } from "../config/survey-config";
import { DEFAULT_CONTEXT_ID } from "../config/survey-paths";

export enum ContextEntityPrefixEnum {
  PERSONA = "persona",
  DISABILITY = "disability",
  HOUSEHOLD_MEMBER = "household_member",
  ACTIVITY = "activity",
  REAL_ESTATE = "real_estate",
  INCOME = "income",
  CR = "CR",
}

export type ContextIdType =
  | `${Exclude<ContextEntityPrefixEnum, ContextEntityPrefixEnum.CR>}:${UUID}`
  | `${ContextEntityPrefixEnum.CR}:${string}`;

export function addContextIdToPathOrDefault(path: string, contextId?: ContextIdType, enableFastForward?: boolean) {
  const newPath = path.replace(":contextId", contextId || DEFAULT_CONTEXT_ID);
  return enableFastForward ? `${newPath}?${SURVEY_QUERY_PARAMS.MODE}=${SURVEY_MODE.FAST_FORWARD}` : newPath;
}
